import React from "react";
import ProviderOverviewSection from "./ProviderOverviewSection";
import ProviderLanguagesSection from "./ProviderLanguagesSection";
import "./providerInfo.scss";
import ProviderSpeciality from "./ProviderSpeciality";

const ProviderInfo = () => {
  
  return (
    <div className="container-right">
      <div>
        <ProviderOverviewSection />
      </div>
      <ProviderSpeciality  />
      <ProviderLanguagesSection  />
    </div>
  );
};

export default ProviderInfo;
